var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"product-listing"},_vm._l((_vm.productsParsed),function(product){return _c('product-content',{key:product.id,attrs:{"product":product}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }